//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        birthYear: {
            type: Number,
            required: false,
            default: null,
        },
        hasDisability: {
            type: Boolean,
            required: true,
        },
        setBirthYear: {
            type: Function,
            required: true,
        },
        setHasDisability: {
            type: Function,
            required: true,
        },
        removeChild: {
            type: Function,
            required: true,
        },
        isRemoveBtnLight: {
            type: Boolean,
            required: false,
            default: false,
        },
        isRemovable: {
            type: Boolean,
            required: false,
            default: true,
        },
        isFieldDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isCalendarFocused: false,
        };
    },
    computed: {
        childBirthYear: {
            get() {
                return this.birthYear ? String(this.birthYear) : null;
            },
            set(value) {
                if (value && String(value).length >= 4) {
                    this.setBirthYear(this.id, +this.$dayjs(value).format('YYYY'));
                }
            },
        },
        childHasDisability: {
            get() {
                return this.hasDisability;
            },
            set(value) {
                this.setHasDisability(this.id, value);
            },
        },
        disabled() {
            return this.isFieldDisabled ? 'disabled' : '';
        },
    },
    methods: {
        handleKeydown(event) {
            if (event.key === 'Enter') {
                this.$refs.calendar.overlayVisible = false;
            }
        },
    },
};
